import React, { useEffect, useRef, useState } from "react";
import * as SS from "../../styles/SidebarStyled";
import * as NS from "../../styles/NavStyled";
import * as CS from "../../styles/CommonStyled";
import mainLogo from "../../assets/images/rainLogo.png";
import darkLogo from "../../assets/images/rainDarkSvg.svg";
import crossGrey from "../../assets/images/crossGrey.png";
import { SidebarData } from "./SidebarData";
import logoutLogo from "../../assets/images/logoutIcon.png";
import downArrowSide from "../../assets/images/downArrowSide.png";
import darkArrowSide from "../../assets/images/darkArrowSide.png";
import AvatarIcon from "../../assets/images/profileDemo.png";
import profileDemo from "../../assets/images/profileDemo.png";
import accountIcon from "../../assets/images/accountIcon.png";
import {
  setAccessToken,
  setErrorPop,
  setErrorPopMsg,
  setIsDark,
  setIsOnBoardingSet,
  setSidebarIsOpens,
  setUserData,
} from "../../store/action";
import * as HS from "../../styles/HeaderStyled";
import lightSun from "../../assets/images/light.png";
import lightMoon from "../../assets/images/dark.png";
import { useSelector } from "react-redux";
import * as LS from "../../styles/LearnerStyled";
import Switch from "../../components/Switch/Switch";
import { Course, Episode, GetNotification } from "../../utils/api";
import logoutIconGrey from "../../assets/images/logoutIconGrey.png";
import axios from "../../utils/axios";
import { jwtDecode } from "jwt-decode";
import { convertSecondsToTimeString } from "../../utils/Helpers";
import learnerSwitch from "../../assets/images/learnerSwitch.png";
import rainLightLogo from "../../assets/images/rainLightSvg.svg";

const Sidebar = ({ theme, navigate, dispatch }) => {
  const access_token = useSelector((state) => state?.access_token);

  const [isOpen, setIsOpen] = useState(true);
  const [isOpenTwo, setIsOpenTwo] = useState(false);
  const [isActive, setIsActive] = useState(null);
  const profileData = useSelector((state) => state?.profileData);
  // const [sidebarIsOpen, setSidebarIsOpen] = useState(true);
  const sidebarIsOpens = useSelector((state) => state?.sidebarIsOpen);
  const sidebarToggle = useSelector((state) => state?.isSidebarToggle);
  const selectLangJson = useSelector((state) => state?.selectLangJson);
  const [sidebarIsOpen, setSidebarIsOpen] = useState(sidebarIsOpens);
  const videoPlay = useSelector((state) => state?.videoPlay);
  const courseId = useSelector((state) => state?.courseId);
  const episodeId = useSelector((state) => state?.episodeId);
  const episodeSelectLang = useSelector((state) => state?.episodeSelectLang);
  const timeStamp = useSelector((state) => state?.timeStamp);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const dynamicRoutes = useSelector((state) =>
    state?.dynamicRoutes ? `/${state?.dynamicRoutes}` : ""
  );
  const [opens, setOpens] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const decoded = jwtDecode(access_token);
  const { userId } = decoded;

  const profileRef = useRef(null);
  const handleConfirm = () => {
    setDeleteSuccess(true);
    setIsOpen(false);
    setOpens(false);

    setSidebarIsOpen(false);
    dispatch(setSidebarIsOpens(false));
    setTimeout(() => {
      setDeleteSuccess(false);
      localStorage.removeItem("rainLearnerData");
      localStorage.removeItem("rainLearnerToken");
      localStorage.removeItem("rainLearnerLang");
      localStorage.removeItem("languagesObj");
      localStorage.removeItem("isActionDisabled");
      localStorage.removeItem("rainRMUserData");
      localStorage.removeItem("rainLearnerCourseId");
      localStorage.removeItem("rainClientUserData");
      localStorage.removeItem("rainRoute");
      dispatch(setUserData(""));
      dispatch(setUserData(""));
      dispatch(setUserData(""));
      dispatch(setAccessToken(""));
      window.location.href = "/";
    }, 2000);
  };
  const removeImpersonate = async () => {
    try {
      let url = GetNotification.removeImpersonate;
      const { data } = await axios.get(url);
      console.log(data?.data);

      if (data?.data) {
        handleConfirm();
        if (decoded?.clientAdmin) {
          if (data?.data.redirect) window.location.href = data?.data.redirect;
        } else {
          window.close();
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        handleConfirm();
      }
    }
  };

  const handleThemeChange = () => {};

  // console.log(profileData, "profileData profileData");

  useEffect(() => {
    function handleClickOutside(event) {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profileRef]);

  const handleImpersonate = async () => {
    try {
      let url = `${Course.getImpersonateLink}/${userId}?userType=client_admin`;
      const { data } = await axios.get(url);
      if (data) {
        window.location.href = data;
        setIsOpenTwo(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        dispatch(setErrorPop(true));
        dispatch(setErrorPopMsg(error?.response?.data?.message));
      }
      setIsOpenTwo(false);
      console.log(error.response.data.message);
    }
  };
  return (
    <div>
      <SS.SidebarContainerResp
        sidebarIsOpen={sidebarIsOpens}
        themeColor={theme}
      >
        <SS.InnerSidebar themeColor={theme}>
          <SS.LogoListBox>
            <SS.LogoRow>
              {/* <SS.MainLogo>
                <img
                  src={theme ? darkLogo : mainLogo}
                  alt=""
                  style={{ display: isOpen ? "block" : "none" }}
                />
              </SS.MainLogo> */}
              {theme ? (
                <HS.MainLogoTwo
                  onClick={() => navigate("/client-admin/dashboard")}
                >
                  <img src={darkLogo} alt="" />
                </HS.MainLogoTwo>
              ) : (
                <HS.MainLogoTwo
                  onClick={() => navigate("/client-admin/dashboard")}
                >
                  <img src={rainLightLogo} alt="" />
                </HS.MainLogoTwo>
              )}
              <SS.ArrowLogoResp
                src={crossGrey}
                alt=""
                onClick={() => {
                  dispatch(setSidebarIsOpens(false));
                }}
              />
            </SS.LogoRow>

            <SS.MenuBox>
              <SS.MenuRow
                themeColor={theme}
                activeColor={SidebarData[0].activeTab?.includes(
                  window.location.pathname
                )}
                onClick={() => {
                  setIsActive(null);
                  navigate("/client-admin/dashboard");
                  setSidebarIsOpen(false);
                  dispatch(setSidebarIsOpens(false));
                }}
              >
                <div className="row-wise">
                  <img
                    src={
                      SidebarData[0].activeTab?.includes(
                        window.location.pathname
                      )
                        ? SidebarData[0].activeIcon
                        : SidebarData[0].icon
                    }
                    alt=""
                  />
                  {isOpen && SidebarData[0].title}
                </div>
              </SS.MenuRow>
            </SS.MenuBox>

            <SS.MenuBox>
              <SS.MenuRow
                themeColor={theme}
                activeColor={SidebarData[1].activeTab?.includes(
                  window.location.pathname
                )}
                onClick={() => {
                  setIsActive(null);
                  navigate("/client-admin/courses");
                  setSidebarIsOpen(false);
                  dispatch(setSidebarIsOpens(false));
                }}
              >
                <div className="row-wise">
                  <img
                    src={
                      SidebarData[1].activeTab?.includes(
                        window.location.pathname
                      )
                        ? SidebarData[1].activeIcon
                        : SidebarData[1].icon
                    }
                    alt=""
                  />
                  {isOpen && SidebarData[1].title}
                </div>
              </SS.MenuRow>
            </SS.MenuBox>

            <SS.MenuBox>
              <SS.MenuRow
                themeColor={theme}
                activeColor={SidebarData[2].activeTab?.includes(
                  window.location.pathname
                )}
                onClick={() => {
                  setIsActive(null);
                  navigate("/client-admin/reports/master-reports");
                  setSidebarIsOpen(false);
                  dispatch(setSidebarIsOpens(false));
                }}
              >
                <div className="row-wise">
                  <img
                    src={
                      SidebarData[2].activeTab?.includes(
                        window.location.pathname
                      )
                        ? SidebarData[2].activeIcon
                        : SidebarData[2].icon
                    }
                    alt=""
                  />
                  {isOpen && SidebarData[2].title}
                </div>
              </SS.MenuRow>
            </SS.MenuBox>
            <SS.MenuBox>
              <SS.MenuRow
                themeColor={theme}
                activeColor={SidebarData[3].activeTab?.includes(
                  window.location.pathname
                )}
                onClick={() => {
                  if (isActive) {
                    setIsActive(null);
                  } else {
                    setIsActive(SidebarData[3]);
                  }
                }}
              >
                <div className="row-wise">
                  <img
                    src={
                      SidebarData[3].activeTab?.includes(
                        window.location.pathname
                      )
                        ? SidebarData[3].activeIcon
                        : SidebarData[3].icon
                    }
                    alt=""
                  />
                  {isOpen && SidebarData[3].title}
                </div>
                <img
                  className="arrow-img"
                  src={isActive ? darkArrowSide : downArrowSide}
                  alt=""
                />
              </SS.MenuRow>
              {isActive && (
                <SS.SubMenuBox isActive={isActive} themeColor={theme}>
                  <SS.ActiveSub
                    themeColor={theme}
                    onClick={() => {
                      setSidebarIsOpen(false);
                      dispatch(setSidebarIsOpens(false));
                    }}
                  >
                    {SidebarData[3].subMenu[0]?.label}
                  </SS.ActiveSub>
                  <SS.ActiveSub
                    themeColor={theme}
                    onClick={() => {
                      setSidebarIsOpen(false);
                      dispatch(setSidebarIsOpens(false));
                    }}
                  >
                    {SidebarData[3].subMenu[1]?.label}
                  </SS.ActiveSub>
                  <SS.ActiveSub
                    themeColor={theme}
                    onClick={() => {
                      setSidebarIsOpen(false);
                      dispatch(setSidebarIsOpens(false));
                      dispatch(setIsOnBoardingSet(true));
                    }}
                  >
                    {SidebarData[3].subMenu[2].label}
                  </SS.ActiveSub>
                </SS.SubMenuBox>
              )}
            </SS.MenuBox>
          </SS.LogoListBox>
          <SS.BottomContainer>
            <HS.ComMenuBoxCon
              themeColor={theme}
              style={{
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={theme ? lightMoon : lightSun} alt="" />
                {selectLangJson.light_theme}
              </div>
              <LS.DefaultToggle>
                <Switch
                  rounded={true}
                  isToggled={theme}
                  bgColorChecked="#F6591C"
                  roundColorChecked="#ffffff"
                  border={theme ? "1px solid transparent" : "1px solid #D7DAE0"}
                  themeColor={theme}
                  wiDth={"40px"}
                  bgColorUnChecked={theme ? "#1F242F" : "#D7DAE0"}
                  roundColorUnChecked="#ffffff"
                  onToggle={() => {
                    const newTheme = !theme;
                    localStorage.setItem("rainTheme", newTheme); // Save theme to local storage
                    dispatch(setIsDark(newTheme));
                  }}
                />
              </LS.DefaultToggle>
            </HS.ComMenuBoxCon>
            <SS.LogOutBoxResp
              themeColor={theme}
              onClick={() => {
                setIsProfileOpen(true);
              }}
            >
              <NS.AvatarSidebar
              // onClick={() => {
              //   setIsProfileOpen(!isProfileOpen);
              // }}
              >
                <img src={profileData?.profileImage || profileDemo} alt="" />
              </NS.AvatarSidebar>
              <CS.TitleColumn>
                <CS.ColumnTitle
                  style={{ textTransform: "capitalize" }}
                  themeColor={theme}
                >
                  {" "}
                  {profileData?.firstName} {profileData?.lastName}
                </CS.ColumnTitle>
                <CS.ColumnEmail
                  style={{
                    whiteSpace: "nowrap",
                    width: "170px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    marginTop: "3px",
                  }}
                  themeColor={theme}
                >
                  {profileData?.email}
                </CS.ColumnEmail>
              </CS.TitleColumn>
            </SS.LogOutBoxResp>
            {isProfileOpen ? (
              <HS.AccountBoxTwo themeColor={theme} ref={profileRef}>
                <HS.ProfileRow themeColor={theme}>
                  <HS.ProfileBox>
                    <img
                      src={profileData?.profileImage || profileDemo}
                      alt=""
                    />
                  </HS.ProfileBox>
                  <HS.NameBox themeColor={theme}>
                    <HS.NameTitle themeColor={theme}>
                      {profileData?.firstName} {profileData?.lastName}
                    </HS.NameTitle>
                    <HS.NameEmail themeColor={theme}>
                      {profileData?.email}
                    </HS.NameEmail>
                  </HS.NameBox>
                </HS.ProfileRow>
                <HS.ComMenuBoxNoBorder
                  themeColor={theme}
                  to={"/client-admin/profile-details"}
                  onClick={() => {
                    setSidebarIsOpen(false);
                    dispatch(setSidebarIsOpens(false));
                  }}
                >
                  <img src={accountIcon} alt="" />
                  {selectLangJson?.account_settings}
                </HS.ComMenuBoxNoBorder>
                {/* <HS.ComMenuBox
                    themeColor={theme}
                    to="/learner/profile-details"
                    onClick={() => {
                      setIsProfileOpen(false);
                      dispatch(setVideoPlay(false));
                    }}
                  >
                    <img src={lightConfigure} alt="" />
                    {selectLangJson.settings}
                  </HS.ComMenuBox> */}
                <HS.ComMenuBoxCon
                  themeColor={theme}
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={learnerSwitch} alt="" />
                    {selectLangJson?.switch_to_learner}
                  </div>
                  <LS.DefaultToggle>
                    <Switch
                      rounded={true}
                      isToggled={isOpenTwo}
                      bgColorChecked="#F6591C"
                      roundColorChecked="#ffffff"
                      border={
                        theme ? "1px solid transparent" : "1px solid #D7DAE0"
                      }
                      themeColor={theme}
                      wiDth={"40px"}
                      bgColorUnChecked={theme ? "#1F242F" : "#D7DAE0"}
                      roundColorUnChecked="#ffffff"
                      onToggle={() => {
                        setIsOpenTwo(true);
                        handleImpersonate();
                      }}
                    />
                  </LS.DefaultToggle>
                </HS.ComMenuBoxCon>

                <HS.ComMenuBox
                  themeColor={theme}
                  onClick={handleConfirm}
                  style={{ border: "none" }}
                >
                  <img src={logoutIconGrey} alt="" />
                  {selectLangJson.log_out}
                </HS.ComMenuBox>
              </HS.AccountBoxTwo>
            ) : (
              ""
            )}
          </SS.BottomContainer>
        </SS.InnerSidebar>
        <SS.InnerSidebarBlank></SS.InnerSidebarBlank>
      </SS.SidebarContainerResp>
    </div>
  );
};

export default Sidebar;
